exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".action-tray .icon{color:#505050!important}.action-tray{margin-right:2px;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-ms-flex-pack:end;justify-content:flex-end;height:100%}.action-tray .btn.btn--large{min-width:100px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/actions-tray/ActionsTray.vue
// module id = 1087
// module chunks = 22